import React from "react";
import "./Button.css";

const CalcButton = ({ className, value, onClick }) => {
  return (
    <button className={className} onClick={onClick}>
      {value}
    </button>
  );
};

export default CalcButton;
